<script lang="ts" setup>
defineProps({
  companies: {
    default: () => [],
    type: Array as PropType<CompanyAcquisition[] | CompanyV2[] | CompanyV2Simplified[]>,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
})

const emit = defineEmits<{
  companyClicked: [domain: string]
}>()

const { checkAvailableCredits } = useSubscription()

function onCompanyClick(domain?: string) {
  if (domain && checkAvailableCredits()) {
    emit('companyClicked', domain)
  }
}
</script>

<template>
  <div class="companies-grid">
    <div class="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <template v-for="(company, companyIndex) in companies">
        <UButton
          v-if="companyIndex < max"
          :key="companyIndex"
          class="group relative flex cursor-pointer flex-col items-center text-center hover:no-underline"
          variant="link"
          @click="onCompanyClick(typeof company.domain === 'object' ? company.domain.domain : company.domain)"
        >
          <div class="relative flex w-full flex-col items-center rounded-lg border border-gray-200 bg-gray-100 p-2 uppercase transition group-hover:border-gray-300 dark:border-gray-800 dark:bg-gray-900 dark:group-hover:border-gray-700">
            <UAvatar
              class="flex-initial"
              :icon="getIcon('companies')"
              size="xl"
              :src=" getLogo(typeof company.domain === 'object' ? company.domain.domain : company.domain, 'companies') "
            />
          </div>

          <div class="w-full overflow-hidden truncate">
            <span class="mt-2 text-xs uppercase text-gray-800 dark:text-gray-200">
              {{ 'name' in company ? company.name : 'about' in company ? company.about?.name : '' }}
            </span>
          </div>
        </UButton>
      </template>
    </div>

    <slot />
  </div>
</template>
